import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { AssetService } from '../../../../Services/asset.service';
import { NotificationService } from '../../../../Services/notification.service';
import { Asset } from '../../../../Models/asset';
import { HttpParams } from '@angular/common/http';
import { UserSupplierService } from '../../../../Services/User/Supplier/user-supplier.service';

@Component({
  selector: 'app-admin-assets',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './admin-assets.component.html',
  styleUrls: ['./admin-assets.component.css']
})
export class AdminAssetsComponent implements OnInit {

  @Input() kalakarId?: number;   // 👈 made optional

  assignForm!: FormGroup;
  isSubmitting = false;
  allAssets: Asset[] = [];
  assignedAssets: Asset[] = [];
  availableAssets: Asset[] = [];
  kalakarName: any;
  userType : any ='Karigar';

  constructor(
    private fb: FormBuilder,
    private assetService: AssetService,
    private notificationService: NotificationService,
    private supplierService: UserSupplierService,
    private route: ActivatedRoute   // 👈 added
  ) { }

  ngOnInit(): void {

    this.assignForm = this.fb.group({
      assetToAssignId: [null, Validators.required]
    });

    // ✅ If ID comes from parent component via @Input
    if (this.kalakarId) {
      this.initializeData();
      return;
    }

    // ✅ Otherwise get from parent route
    this.route.parent?.paramMap.subscribe(params => {
      const routeId = params.get('staffId');
      this.userType = 'Staff';
      console.log("Parent Route ID:", routeId);

      if (routeId) {
        this.kalakarId = +routeId;
        this.initializeData();
      } else {
        this.notificationService.showError('Kalakar ID not found.', 'Error');
      }
    });
  }

  initializeData(): void {
    if (!this.kalakarId) return;

    this.loadAllAssets();
    this.getKalakarName();
  }

  getKalakarName() {
    if (!this.kalakarId) return;

    this.supplierService.getUserSupplierById(this.kalakarId).subscribe((res: any) => {
      this.kalakarName = res.data.name;
    });
  }

  loadAllAssets(): void {
    if (!this.kalakarId) return;

    this.assetService.getAssets().subscribe({
      next: (response: any) => {
        this.allAssets = response.data || [];
        this.filterAssets();
      },
      error: (err) => {
        this.notificationService.showError('Could not fetch asset data.', 'API Error');
        console.error(err);
      }
    });
  }

  filterAssets(): void {
    if (!this.kalakarId) return;

    const params = new HttpParams().append('kalakar_id', this.kalakarId.toString());

    this.assetService.getAssets(params).subscribe((res: any) => {
      this.assignedAssets = res.data;
      this.availableAssets = this.allAssets.filter(asset => asset.kalakar_id === null);
    });
  }

  onAssignSubmit(): void {
    if (this.assignForm.invalid || !this.kalakarId) {
      this.notificationService.showError('Please select an asset to assign.', 'Validation Error');
      return;
    }

    this.isSubmitting = true;
    const assetId = this.assignForm.get('assetToAssignId')?.value;

    const payload = {
      kalakar_id: this.kalakarId,
      date: new Date().toISOString().split('T')[0]
    };

    this.assetService.updateAsset(assetId, payload).subscribe({
      next: () => {
        this.notificationService.showSuccess('Asset assigned successfully!', 'Success');
        this.assignForm.reset();
        this.loadAllAssets();
      },
      error: (err) => {
        this.notificationService.showError('Failed to assign asset.', 'API Error');
        console.error(err);
      },
      complete: () => this.isSubmitting = false
    });
  }

  onReturnAsset(assetId: number | undefined): void {
    if (!assetId) return;

    if (confirm('Are you sure you want to return this asset to the inventory? This action cannot be undone.')) {
      const payload = {
        kalakar_id: null,
        date: null,
        receipt_acknowledged_at: null,
        issue_reported_at: null,
        return_requested_at: null
      };

      this.assetService.updateAsset(assetId, payload).subscribe({
        next: () => {
          this.notificationService.showSuccess('Asset returned to inventory successfully!', 'Success');
          this.loadAllAssets();
        },
        error: (err) => {
          this.notificationService.showError('Failed to return asset.', 'API Error');
          console.error(err);
        }
      });
    }
  }
}